import React from 'react';
import PropTypes from 'prop-types';

import forwardRefWithTranslation from '@/common/forwardRefWithTranslation';

class OrderServiceFee extends React.Component {
    static propTypes = {
        service_fee: PropTypes.object.isRequired,
        t: PropTypes.func.isRequired,
    };

    render() {
        const { t, service_fee } = this.props;
        const base_class = "m2g-order-confirmation-item";
        const fee_class = "m2g-order-confirmation-service-fee";
        return (
            <tr className={`${base_class} ${fee_class}`}>
                <td className={`${base_class}-thumbnail`} />
                <td className={`${base_class}-content`}>
                    {t('label')}
                    <div
                        className={`${fee_class}-icon m2g-icon m2g-icon--info-o`}
                        onClick={() => window.Mobi2Go.UI.centeredAlert({
                            title: t("service_fee_alert_title"),
                            body: t("service_fee_alert_description"),
                            primary_button: t("dismiss")
                        })}
                    />
                </td>
                <td
                    data-service_fee={service_fee}
                    className={`${base_class}-total`}
                >
                    {t('common:price', { price: service_fee.getListPrice() })}
                </td>
            </tr>
        );
    }
}

export default forwardRefWithTranslation('order.service-fee')(
    OrderServiceFee
);
